import styled from 'styled-components';
import { colors } from '../../../styles/variables';

export const PositionIndex = styled.span`
  background: ${props => (props.background ? props.background : colors.black)};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: ${props => (props.textShadow ? props.textShadow : 'none')};
`;
